import { createFileRoute } from '@tanstack/react-router';
import { CountriesListView } from '@/features/countries';

export const Route = createFileRoute('/_auth/countries')({
  component: CountriesPage,
});

function CountriesPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Countries</h1>
      <CountriesListView />
    </div>
  );
}
